import { useState } from 'react';
import { ArrowLeft, BookOpen, Search } from 'lucide-react';
import { ARTIGOS_AJUDA, blocosAjuda, buscarAjuda } from '../lib/ajuda';
import { ConteudoAjuda } from '../components/ajuda/artigo-ajuda';

export function AjudaPage() {
  const [busca, setBusca] = useState('');
  const topico = new URLSearchParams(window.location.search).get('topico');
  const artigo = ARTIGOS_AJUDA.find((item) => item.id === topico);
  const encontrados = buscarAjuda(busca);
  const secoes = artigo ? blocosAjuda(artigo.texto).flatMap((bloco, indice) => bloco.tipo === 'titulo' ? [{ titulo: bloco.texto, id: `guia-${indice}` }] : []) : [];
  return <section className="ajuda-pagina" aria-label="Central de ajuda">
    <header className="ajuda-cabecalho">
      <p className="ajuda-sobretitulo"><BookOpen size={18} aria-hidden="true" /> Guia de operação</p>
      <h1>Central de ajuda</h1>
      <p>Do pedido à saída do material: encontre o próximo passo e entenda o que falta para continuar.</p>
      <p className="ajuda-revisao">Conteúdo revisado em 21/10/2026 · As ações disponíveis dependem do seu perfil.</p>
    </header>
    {artigo ? <>
      <a className="ajuda-link" href="/ajuda"><ArrowLeft size={18} aria-hidden="true" /> Todos os assuntos</a>
      <article className="ajuda-artigo"><h2>{artigo.titulo}</h2>
        <nav className="ajuda-indice" aria-label="Neste guia"><p>Neste guia</p><ul>{secoes.map((secao) => <li key={secao.id}><a href={`#${secao.id}`}>{secao.titulo}</a></li>)}</ul></nav>
        <ConteudoAjuda artigo={artigo} prefixoSecao="guia" />
      </article>
      <nav className="ajuda-outros" aria-label="Outros guias"><h2>Consulte também</h2><div>{ARTIGOS_AJUDA.filter((item) => item.id !== artigo.id).map((item) => <a className="ajuda-link" key={item.id} href={`/ajuda?topico=${item.id}`}>{item.titulo}</a>)}</div></nav>
    </> : <>
      {topico && <p role="status">Este assunto não foi encontrado. Escolha um dos guias abaixo.</p>}
      {!busca.trim() && <nav className="ajuda-iniciar" aria-label="Por onde começar"><h2>Por onde começar?</h2><p><a className="ajuda-link" href="/ajuda?topico=manual">Manual de operação completo — do pedido à expedição</a></p><p>Prepare o cadastro, escolha o tratamento no pedido e confira a chegada do material.</p><ol>
        <li><a href="/ajuda?topico=pecas">Cadastrar uma peça / produto</a></li>
        <li><a href="/ajuda?topico=tratamentos">Definir tratamentos por pedido</a></li>
        <li><a href="/ajuda?topico=pedido">Preparar o pedido de venda</a></li>
        <li><a href="/ajuda?topico=recebimento">Receber a remessa / NF-e</a></li>
      </ol></nav>}
      <div className="ajuda-busca">
        <label htmlFor="busca-ajuda">O que você precisa fazer?</label>
        <div><Search size={20} aria-hidden="true" /><input id="busca-ajuda" type="search" value={busca} onChange={(event) => setBusca(event.target.value)} placeholder="Ex.: produto, tratamento, lote, NF-e…" /></div>
      </div>
      <p role="status" aria-live="polite" className="ajuda-contagem">{encontrados.length} {encontrados.length === 1 ? 'assunto encontrado' : 'assuntos encontrados'}</p>
      {encontrados.length === 0 ? <div className="ajuda-vazio"><h2>Nenhum assunto encontrado</h2><p>Tente uma palavra mais simples, como pedido, lote ou roteiro.</p><button className="ajuda-acionador" onClick={() => setBusca('')}>Limpar busca</button></div> : <nav className="ajuda-grade" aria-label="Assuntos da ajuda">
        {encontrados.map((item) => <a className="ajuda-cartao" key={item.id} href={`/ajuda?topico=${item.id}`}>
          <h2>{item.titulo}</h2><p>{item.resumo}</p><span>Ler passo a passo →</span>
        </a>)}
      </nav>}
    </>}
  </section>;
}
